import React, { useContext } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Plan, PlanDetailsSection as PDS } from "../../../@types";
import { planDataUtils, useTranslate, $$ } from "../../../helpers";
import {
  PlanDetailSection,
  PlanDetailList,
  DetailItem,
} from "../../../components";
import { AppContext } from "../../../app/store";
import { shouldSuppressPlanBenefits } from "../../../helpers/planHelpers";

const Overview: React.FunctionComponent<{ plan: Plan }> = ({ plan }) => {
  const { state } = useContext(AppContext);
  const { mctCurrentPlanYear } = useFlags();
  const t = useTranslate();

  return (
    <PlanDetailSection title={t("plan_terms.overview")}>
      <PlanDetailList id={PDS.PREMIUM} title={t("plan_terms.premium")}>
        <DetailItem
          detail={$$(plan.calculated_monthly_premium)}
          label={t("plan_terms.total_monthly_premium")}
          suppressed={shouldSuppressPlanBenefits(plan)}
        />
      </PlanDetailList>

      <PlanDetailList id={PDS.DEDUCTIBLE} title={t("plan_terms.deductible")}>
        <DetailItem
          detail={planDataUtils.getAnnualDrugDeductible(
            state,
            mctCurrentPlanYear,
            plan
          )}
          label={t("plan_terms.drug_plan_deductible")}
          suppressed={shouldSuppressPlanBenefits(plan)}
        />
      </PlanDetailList>
    </PlanDetailSection>
  );
};

export default Overview;
